import axios from "axios";

// const baseUrl = process.env.REACT_APP_BACKEND_BASE_URL;

const instance = axios.create({
    // baseURL: 'http://localhost:5259/api/v1',
    //baseURL: 'https://kering-dev-apeevo-website-backend.cloud4fashion.net/api/v1/',
    baseURL: process.env.REACT_APP_BASE_URL,
    headers: {
        'Access-Control-Allow-Origin': '*',
        // 'Access-Control-Request-Method': 'PUT, GET, HEAD, POST, DELETE, OPTIONS',
        'Access-Control-Allow-Headers': '*',
        // 'Access-Control-Expose-Headers': 'Content-Disposition'
    }
});

export default instance;     